/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { Journey } from '@/client/models';
/**
 * JourneysApi - axios parameter creator
 */
export const JourneysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Plan a journey between two points
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} from Origin location ID
         * @param {string} to Destination location ID
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {CoverageCoverageJourneysGetDatetimeRepresentsEnum} [datetimeRepresents] Whether datetime represents departure or arrival
         * @param {CoverageCoverageJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness: base_schedule or realtime
         * @param {number} [count] Number of results to return
         * @param {number} [maxDuration] Maximum journey duration in seconds
         * @param {number} [minNbJourneys] Minimum number of journeys to return
         * @param {number} [timeframeDuration] Timeframe duration in seconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageJourneysGet: async (coverage: string, from: string, to: string, datetime?: string, datetimeRepresents?: CoverageCoverageJourneysGetDatetimeRepresentsEnum, dataFreshness?: CoverageCoverageJourneysGetDataFreshnessEnum, count?: number, maxDuration?: number, minNbJourneys?: number, timeframeDuration?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageJourneysGet', 'coverage', coverage)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('coverageCoverageJourneysGet', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('coverageCoverageJourneysGet', 'to', to)
            const localVarPath = `/coverage/{coverage}/journeys`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (datetime !== undefined) {
                localVarQueryParameter['datetime'] = datetime;
            }

            if (datetimeRepresents !== undefined) {
                localVarQueryParameter['datetime_represents'] = datetimeRepresents;
            }

            if (dataFreshness !== undefined) {
                localVarQueryParameter['data_freshness'] = dataFreshness;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (maxDuration !== undefined) {
                localVarQueryParameter['max_duration'] = maxDuration;
            }

            if (minNbJourneys !== undefined) {
                localVarQueryParameter['min_nb_journeys'] = minNbJourneys;
            }

            if (timeframeDuration !== undefined) {
                localVarQueryParameter['timeframe_duration'] = timeframeDuration;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JourneysApi - functional programming interface
 */
export const JourneysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JourneysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Plan a journey between two points
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} from Origin location ID
         * @param {string} to Destination location ID
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {CoverageCoverageJourneysGetDatetimeRepresentsEnum} [datetimeRepresents] Whether datetime represents departure or arrival
         * @param {CoverageCoverageJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness: base_schedule or realtime
         * @param {number} [count] Number of results to return
         * @param {number} [maxDuration] Maximum journey duration in seconds
         * @param {number} [minNbJourneys] Minimum number of journeys to return
         * @param {number} [timeframeDuration] Timeframe duration in seconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageJourneysGet(coverage: string, from: string, to: string, datetime?: string, datetimeRepresents?: CoverageCoverageJourneysGetDatetimeRepresentsEnum, dataFreshness?: CoverageCoverageJourneysGetDataFreshnessEnum, count?: number, maxDuration?: number, minNbJourneys?: number, timeframeDuration?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Journey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageJourneysGet(coverage, from, to, datetime, datetimeRepresents, dataFreshness, count, maxDuration, minNbJourneys, timeframeDuration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JourneysApi.coverageCoverageJourneysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JourneysApi - factory interface
 */
export const JourneysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JourneysApiFp(configuration)
    return {
        /**
         * 
         * @summary Plan a journey between two points
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} from Origin location ID
         * @param {string} to Destination location ID
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {CoverageCoverageJourneysGetDatetimeRepresentsEnum} [datetimeRepresents] Whether datetime represents departure or arrival
         * @param {CoverageCoverageJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness: base_schedule or realtime
         * @param {number} [count] Number of results to return
         * @param {number} [maxDuration] Maximum journey duration in seconds
         * @param {number} [minNbJourneys] Minimum number of journeys to return
         * @param {number} [timeframeDuration] Timeframe duration in seconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageJourneysGet(coverage: string, from: string, to: string, datetime?: string, datetimeRepresents?: CoverageCoverageJourneysGetDatetimeRepresentsEnum, dataFreshness?: CoverageCoverageJourneysGetDataFreshnessEnum, count?: number, maxDuration?: number, minNbJourneys?: number, timeframeDuration?: number, options?: RawAxiosRequestConfig): AxiosPromise<Journey> {
            return localVarFp.coverageCoverageJourneysGet(coverage, from, to, datetime, datetimeRepresents, dataFreshness, count, maxDuration, minNbJourneys, timeframeDuration, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JourneysApi - interface
 */
export interface JourneysApiInterface {
    /**
     * 
     * @summary Plan a journey between two points
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} from Origin location ID
     * @param {string} to Destination location ID
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {CoverageCoverageJourneysGetDatetimeRepresentsEnum} [datetimeRepresents] Whether datetime represents departure or arrival
     * @param {CoverageCoverageJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness: base_schedule or realtime
     * @param {number} [count] Number of results to return
     * @param {number} [maxDuration] Maximum journey duration in seconds
     * @param {number} [minNbJourneys] Minimum number of journeys to return
     * @param {number} [timeframeDuration] Timeframe duration in seconds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageJourneysGet(coverage: string, from: string, to: string, datetime?: string, datetimeRepresents?: CoverageCoverageJourneysGetDatetimeRepresentsEnum, dataFreshness?: CoverageCoverageJourneysGetDataFreshnessEnum, count?: number, maxDuration?: number, minNbJourneys?: number, timeframeDuration?: number, options?: RawAxiosRequestConfig): AxiosPromise<Journey>;

}

/**
 * JourneysApi - object-oriented interface
 */
export class JourneysApi extends BaseAPI implements JourneysApiInterface {
    /**
     * 
     * @summary Plan a journey between two points
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} from Origin location ID
     * @param {string} to Destination location ID
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {CoverageCoverageJourneysGetDatetimeRepresentsEnum} [datetimeRepresents] Whether datetime represents departure or arrival
     * @param {CoverageCoverageJourneysGetDataFreshnessEnum} [dataFreshness] Data freshness: base_schedule or realtime
     * @param {number} [count] Number of results to return
     * @param {number} [maxDuration] Maximum journey duration in seconds
     * @param {number} [minNbJourneys] Minimum number of journeys to return
     * @param {number} [timeframeDuration] Timeframe duration in seconds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageJourneysGet(coverage: string, from: string, to: string, datetime?: string, datetimeRepresents?: CoverageCoverageJourneysGetDatetimeRepresentsEnum, dataFreshness?: CoverageCoverageJourneysGetDataFreshnessEnum, count?: number, maxDuration?: number, minNbJourneys?: number, timeframeDuration?: number, options?: RawAxiosRequestConfig) {
        return JourneysApiFp(this.configuration).coverageCoverageJourneysGet(coverage, from, to, datetime, datetimeRepresents, dataFreshness, count, maxDuration, minNbJourneys, timeframeDuration, options).then((request) => request(this.axios, this.basePath));
    }
}

export const CoverageCoverageJourneysGetDatetimeRepresentsEnum = {
    Departure: 'departure',
    Arrival: 'arrival'
} as const;
export type CoverageCoverageJourneysGetDatetimeRepresentsEnum = typeof CoverageCoverageJourneysGetDatetimeRepresentsEnum[keyof typeof CoverageCoverageJourneysGetDatetimeRepresentsEnum];
export const CoverageCoverageJourneysGetDataFreshnessEnum = {
    BaseSchedule: 'base_schedule',
    Realtime: 'realtime'
} as const;
export type CoverageCoverageJourneysGetDataFreshnessEnum = typeof CoverageCoverageJourneysGetDataFreshnessEnum[keyof typeof CoverageCoverageJourneysGetDataFreshnessEnum];
